/* eslint-disable react/prop-types */
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Typography,
  Button,
  withStyles,
  useMediaQuery,
} from "@material-ui/core";
import _ from "lodash";
import { AiOutlineComment } from "react-icons/ai";
import { FaRegCalendarAlt, FaUser } from "react-icons/fa";
import { ReactComponent as CancelIcon } from "resources/cancel-icon.svg";
import DescriptionError from "./DescriptionError";
import ImportScenarioCard from "./ImportScenarioCard";

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    maxWidth: "750px",
  },
  dialogTitle: {
    borderBottom: "1px solid #e2e2e2",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
  },
  dialogContent: {
    padding: "25px",
  },
  scenarioDataContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#EEEEEE",
    marginBottom: "20px",
  },
  scenarioDataRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  dataMarginLeft: {
    marginLeft: "2px",
  },
  textDialog: {
    color: "black",
    marginBottom: "15px",
    fontSize: "15px",
  },
  textError: {
    color: "red",
    marginBottom: "5px",
    fontSize: "15px",
    fontWeight: "bold",
  },
  textScenarioName: {
    color: "black",
    fontSize: "16px",
    marginBottom: "5px",
    marginLeft: "5px",
  },
  borderBarTop: {
    borderTop: "1px solid #e2e2e2",
    marginBottom: "25px",
    marginTop: "25px",
  },
  containerCancelIcon: {
    display: "flex",
    flex: 1,
  },
  containerTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  iconColor: {
    color: "white",
  },
}));

const withImportScenario = (WrappedComponent, scenarioTotal) => {
  return (props) => {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    // eslint-disable-next-line
    const [dataError, setDataError] = React.useState("");
    const [dataDescriptionError, setDataDescriptionError] = React.useState(
      "Field will be automaticamally check"
    );
    const isSmallScreen = useMediaQuery((theme) =>
      theme.breakpoints.down("450")
    );

    const handleClickDialogOpen = (e) => {
      e.stopPropagation();
      setDialogOpen(true);
    };

    const handleDialogClose = () => {
      setDialogOpen(false);
    };

    const handleDialogClick = (e) => {
      /**
       * We need to stop the propagation of the click event when clicking
       * anywhere within the dialog window to prevent side effects
       */
      e.stopPropagation();
    };

    const StyledButton = withStyles((theme) => ({
      root: {
        paddingBottom: "9px",
        flex: 1,
        direction: "rtl",
        alignItems: "start",
        color: "#000000",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
        },
      },
      label: {
        justifyContent: "normal",
        fontSize: "17px",
        fontWeight: "bold",
      },
    }))(Button);

    return (
      <>
        <WrappedComponent
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          onClick={handleClickDialogOpen}
          onMouseDown={handleClickDialogOpen}
        />
        {!_.isEmpty(scenarioTotal) && (
          <>
            <Dialog
              open={dialogOpen}
              onClose={handleDialogClose}
              onClick={handleDialogClick}
              fullWidth
              maxWidth="md"
              disableRestoreFocus
              classes={{
                paperWidthMd: classes.dialogRoot,
              }}
            >
              <DialogTitle className={classes.dialogTitle}>
                <div className={classes.containerTitle}>
                  Import prices from .csv
                  <div>
                    <div className={classes.containerCancelIcon}>
                      <StyledButton autoFocus onClick={handleDialogClose}>
                        <CancelIcon
                          className={classes.iconColor}
                          fill="white"
                        />
                      </StyledButton>
                    </div>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent className={classes.dialogContent}>
                <Typography className={classes.textDialog}>
                  To scenario:
                </Typography>
                <div className={classes.scenarioDataContainer}>
                  <Typography className={classes.textScenarioName}>
                    {scenarioTotal.scenario.name}
                  </Typography>
                  <div className={classes.scenarioDataRow}>
                    <AiOutlineComment
                      style={{ marginRight: "2px", marginLeft: "5px" }}
                    />
                    <Typography variant="body2">
                      {scenarioTotal.scenario.comment || "-"}
                    </Typography>
                    <FaRegCalendarAlt
                      style={{
                        marginLeft: isSmallScreen ? "5px" : "35px",
                        marginRight: "2px",
                      }}
                    />
                    <Typography variant="body2">
                      {scenarioTotal.scenario.cycle.label}
                    </Typography>
                    <FaUser
                      style={{
                        marginLeft: isSmallScreen ? "5px" : "35px",
                        marginRight: "2px",
                      }}
                    />
                    <Typography variant="body2">
                      {scenarioTotal.scenario.owner_label}
                    </Typography>
                  </div>
                </div>
                <ImportScenarioCard
                  estimations={scenarioTotal.estimations}
                  setDataError={setDataError}
                  setDataDescriptionError={setDataDescriptionError}
                  scenarioName={scenarioTotal.scenario.name}
                  scenarioId={scenarioTotal.scenario.id}
                  cycleData={scenarioTotal.scenario.cycle}
                  dialogClose={handleDialogClose}
                />
                <div className={classes.borderBarTop} />
                {dataError ? (
                  <Typography className={classes.textError}>
                    {dataError}
                  </Typography>
                ) : null}
                <DescriptionError fieldsData={dataDescriptionError} />
              </DialogContent>
            </Dialog>
          </>
        )}
      </>
    );
  };
};

export default withImportScenario;
